<td class="logo hidden-xs hidden-sm hidden-md">
  <img [src]="item.iconUrl" alt="icon" class="logo" />
</td>
<td class="">
  <div class="d-flex">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.name' | transloco }}
    </div>
    <div class="d-inline-flex text-md-left text-right" data-zid="topflop-name">
      <web-components-instrument-details-link [isin]="item.isin" class="font-medium">
        {{ item.name }}
      </web-components-instrument-details-link>
    </div>
  </div>
  <div class="d-flex text-color-primary">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.isin' | transloco }}
    </div>
    <div class="font-light" data-zid="topflop-isin">{{ item.isin }}</div>
    <web-components-watchlist-toggle [isin]="item.isin" />
  </div>
</td>
<td class="fixed-width">
  <div class="d-flex justify-content-end" data-zid="topflop-quote">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.quote' | transloco }}
    </div>
    @if (item.quote) {
      <div zeroBlink [val]="item.quote">
        {{ item.quote | currency: 'EUR' : 'symbol' : '1.2-8' }}
      </div>
    } @else {
      <div class="text-color-primary">&mdash;</div>
    }
  </div>
</td>
<td class="fixed-width">
  <div class="d-flex justify-content-end" data-zid="topflop-perf-pct">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.perfPct' | transloco }}
    </div>
    @if ((item.quote && item.perfPct === 0) || item.perfPct > 0 || item.perfPct < 0) {
      <div [ngClass]="item.perfPct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ item.perfPct >= 0 ? '+' : '' }}{{ item.perfPct | number: '1.2-2' }} %
      </div>
    } @else {
      <div class="text-right">&mdash;</div>
    }
  </div>
  <div class="d-flex justify-content-end" data-zid="topflop-perf-abs">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.perfAbs' | transloco }}
    </div>
    @if ((item.quote && item.perfAbs === 0) || item.perfAbs > 0 || item.perfAbs < 0) {
      <div [ngClass]="item.perfAbs >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ item.perfAbs >= 0 ? '+' : '' }}{{ item.perfAbs | number: '1.2-8' }}
      </div>
    } @else {
      <div class="text-right">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.quoteTime' | transloco }}
    </div>
    @if (item.quoteTime) {
      <div class="text-color-primary">
        {{ item.quoteTime | date: 'HH:mm:ss' }}
      </div>
    } @else {
      <div class="text-color-primary">&mdash;</div>
    }
  </div>

  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'instrument-detail.instrument-topflop-list.item.quoteDate' | transloco }}
    </div>
    @if (item.quoteTime) {
      <div class="text-color-primary">
        {{ item.quoteTime | date: 'dd.MM.yy' }}
      </div>
    } @else {
      <div class="text-color-primary">&mdash;</div>
    }
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    @if (item.isSavingsplanReady) {
      <div
        class="trade savings-plan cursor-pointer"
        [title]="'instrument-detail.instrument-topflop-list.item.savingsplan-btn.title' | transloco"
        [routerLink]="commonRoutes.postlogin.add_savings_plan + '/' + item.isin"
        data-zid="topflop-savingsplan-btn"
      >
        <svg class="icon icon-24">
          <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
        </svg>
      </div>
    }
    <div
      class="trade buy cursor-pointer"
      [class.disabled]="!item.isBuyable"
      [title]="'instrument-detail.instrument-topflop-list.item.buy-btn.title' | transloco"
      [routerLink]="item.isBuyable ? commonRoutes.postlogin.buyAndSell : undefined"
      [queryParams]="{
        isin: item.isin,
        direction: 'buy',
      }"
      data-zid="topflop-buy-btn"
    >
      {{ 'instrument-detail.instrument-topflop-list.item.buy-btn.label' | transloco }}
    </div>
    <div
      class="trade sell cursor-pointer"
      [class.disabled]="!item.isSellable || !item.hasAssetInPortfolio"
      [title]="'instrument-detail.instrument-topflop-list.item.sell-btn.title' | transloco"
      [routerLink]="item.isSellable && item.hasAssetInPortfolio ? commonRoutes.postlogin.buyAndSell : undefined"
      [queryParams]="{
        isin: item.isin,
        direction: 'sell',
      }"
      data-zid="topflop-sell-btn"
    >
      {{ 'instrument-detail.instrument-topflop-list.item.sell-btn.label' | transloco }}
    </div>
  </div>
</td>
